<template>
  <Transition name="modal-fade">
    <div class="modal-overlay" @click.self="$emit('close')">
      <div class="modal share-sheet">
        <div class="modal-content">
          <p class="share-sheet__title">Dare a friend</p>
          <p class="share-sheet__url">{{ url }}</p>

          <button v-if="canWebShare" class="black-button" @click="webShare">
            <i class="ri-share-line"></i>&nbsp;Share&hellip;
          </button>

          <button class="black-button" @click="copyLink">
            <i class="ri-links-line"></i>&nbsp;{{ copied ? 'Copied!' : 'Copy link' }}
          </button>

          <a class="black-button" :href="mailtoHref" target="_blank" rel="noopener">
            <i class="ri-mail-line"></i>&nbsp;Email
          </a>

          <a class="black-button" :href="blueskyHref" target="_blank" rel="noopener">
            <img src="@/assets/images/bluesky-logo-white.svg" class="share-sheet__icon" alt="">&nbsp;Post on Bluesky
          </a>

          <a class="black-button" :href="whatsappHref" target="_blank" rel="noopener">
            <i class="ri-whatsapp-line"></i>&nbsp;WhatsApp
          </a>

          <button class="black-button" @click="copyForSignal">
            <img src="@/assets/images/signal-logo-white.svg" class="share-sheet__icon" alt="">&nbsp;{{ copiedSignal ? 'Copied!' : 'Copy for Signal' }}
          </button>

          <button class="black-button" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({ url: String });
defineEmits(['close']);

const copied = ref(false);
const copiedSignal = ref(false);
const canWebShare = computed(() => !!navigator.share);

const shareText = 'Can you beat my score on the Tarski logic game?';

const mailtoHref = computed(() =>
  `mailto:?subject=Dare: Tarski logic game&body=${encodeURIComponent(shareText + '\n' + props.url)}`
);
const blueskyHref = computed(() =>
  `https://bsky.app/intent/compose?text=${encodeURIComponent(shareText + ' ' + props.url)}`
);
const whatsappHref = computed(() =>
  `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + props.url)}`
);

async function copyLink() {
  await navigator.clipboard.writeText(props.url);
  copied.value = true;
  setTimeout(() => { copied.value = false; }, 2000);
}

async function copyForSignal() {
  await navigator.clipboard.writeText(shareText + ' ' + props.url);
  copiedSignal.value = true;
  setTimeout(() => { copiedSignal.value = false; }, 2000);
}

async function webShare() {
  try {
    await navigator.share({ title: 'Tarski Dare', text: shareText, url: props.url });
  } catch {
    // user cancelled
  }
}
</script>

<style scoped>
.share-sheet .modal-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 260px;
}

.share-sheet__title {
  font-weight: bold;
  margin: 0;
}

.share-sheet__url {
  font-size: 11px;
  word-break: break-all;
  color: var(--text-color);
  margin: 0;
  opacity: 0.7;
}

.share-sheet .black-button {
  width: 100%;
  text-align: center;
  text-decoration: none;
}

.share-sheet__icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
}
</style>
